export const aboutContent = {
  brandStory: {
    title: '品牌故事',
    paragraphs: [
      '禁漫天堂成立于2018年，由一群热爱漫画文化的年轻人创立。创始团队发现市场上缺乏一个真正以用户体验为核心的成人漫画平台，于是决定打造一个资源丰富、体验流畅、安全可靠的漫画阅读空间。',
      '经过多年的深耕与发展，禁漫天堂已成长为国内领先的成人漫画在线阅读平台。我们与数百家国内外漫画出版商和独立画师建立了合作关系，为用户持续提供海量优质的漫画内容。',
      '禁漫天堂始终秉持"让每个人都能享受漫画的乐趣"的初心，不断优化产品体验，提升服务质量。未来，我们将继续拓展内容资源，引入更多优秀作品，为漫画爱好者打造更完美的阅读平台。'
    ]
  },
  mission: {
    title: '平台使命',
    items: [
      {
        icon: 'ri-star-line',
        title: '品质优先',
        description: '严格筛选漫画内容，确保平台上的每一部作品都具有高品质的画面和引人入胜的故事情节。'
      },
      {
        icon: 'ri-user-heart-line',
        title: '用户至上',
        description: '深入理解用户需求，持续优化产品功能和交互体验，让每一位用户都能享受极致的阅读体验。'
      },
      {
        icon: 'ri-shield-star-line',
        title: '安全可靠',
        description: '采用业界领先的安全技术，全方位保护用户隐私和账号安全，营造安心的阅读环境。'
      },
      {
        icon: 'ri-global-line',
        title: '开放合作',
        description: '积极与国内外漫画创作者和出版机构合作，推动成人漫画行业的健康发展与多元创作。'
      }
    ]
  },
  milestones: [
    { year: '2018', event: '禁漫天堂正式上线，开启成人漫画阅读新纪元' },
    { year: '2019', event: '注册用户突破100万，漫画资源超过2万部' },
    { year: '2020', event: '推出APP客户端，实现移动端全场景覆盖' },
    { year: '2021', event: 'VIP会员体系上线，为用户提供更优质的专属服务' },
    { year: '2022', event: '注册用户突破300万，漫画资源超过6万部' },
    { year: '2023', event: '全球CDN加速网络部署完成，海外用户体验大幅提升' },
    { year: '2024', event: 'AI智能推荐系统上线，个性化阅读体验全面升级' },
    { year: '2025', event: '注册用户突破500万，成为行业领先平台' },
    { year: '2026', event: '持续优化产品体验，拓展内容生态，迈向新高度' }
  ]
};